export interface StructureInterface {
    name: string;
    categoryInfo?: CategoryInterface[];
    placement?: string;
}

export interface CategoryInterface {
    id: number;
    name?: string;
    subCategories?: SubCategoryInterface[];
    games?: GameInterface[];
    action_type?: string;
    action_param?: string;
    category_route?: string;
    category_code?: string;
    ionicon?: string;
    assetpath?: string;
    hide_category?: boolean;
    label?: string;
    display_label?: string;
}

export interface SubCategoryInterface {
    id: number;
    name: string;
    banners?: BannerInterface[];
    games?: GameInterface[];
    banner_type?: string;
    category_code?: string;
    action_param?: string;
    category_route?: string;
    action_type?: string;
    ionicon?: string;
    number_of_rows?: number;
    hide_category?: boolean;
    parent_id?: number;
    hasMoreGames?: boolean;
    max_number_of_games?: number;
    display_label?: string;
}

export interface BannerInterface {
    id: number;
    name: string;
    description: string;
    actionType: string;
    imageLarge: string;
    imageMedium: string;
    imageSmall: string;
    campaignDefinitionInfo?: CampaignInterface;
    url: string;
    display_label?: string;
}

export interface CampaignInterface {
    id: string;
    description: string;
    notificationImage: string;
    campaign_type: string;
    bg_path: string;
    show_banner_flag: string;
    banner_image_large: string;
    banner_image_medium: string;
    banner_image_small: string;
    banner_action: string;
    show_thumbnail_flag: string;
    thumbnail_image: string;
    offer_type: string;
    offer_amount: string;
    display_name: string;
    include_visitors: string;
    end_date: string;
    campaign_code: string;
}

export interface GameInterface {
    ext_game_type?: string;
    extra_launch_data: string;
    game_layout?: string;
    game_name: string;
    game_order: number;
    game_segment: string;
    game_type_id: number;
    id: number;
    imagename: string;
    is_jackpot: number;
    isHotgame: boolean;
    isMvp: boolean;
    keyword_name: string;
    label_color?: string;
    label_name?: string;
    name: string;
    product_name: string;
    RTP: number;
    super_type: string;
    tagCategories?: string[];
    tags: string[];
    vendor_ident: string;
    vendor_name: string;
}

export enum GameLayout {
    large = 'LARGE',
    small = 'SMALL',
    medium = 'MEDIUM',
    vertical = 'VERTICAL',
    horizontal = 'HORIZONTAL',
}

export enum BannerActionType {
    ACQUISITION = 'ACQUISITION',
    DEPOSIT = 'DEPOSIT',
    SIGNUP = 'SIGNUP',
    LOGIN = 'LOGIN',
    EXTERNAL_URL = 'EXTERNAL_URL',
    GAME = 'GAME',
    INTERNAL_NAV = 'INTERNAL_NAV',
    CATEGORY = 'CATEGORY',
    ARTICLE = 'ARTICLE',
    DIALOG = 'DIALOG',
}

export enum OfferType {
    MFREESPIN = 'MFREESPIN',
    COUPON_CODE = 'COUPON_CODE',
}

export enum DepositViewType {
    FULLSCREEN = 'fullscreen',
}